import { ProductBackendName } from "Components/Features/CheckPrice/Products/productTypes";
import { InsuranceCoverage } from "Store/interfaces/products/coverage";
import { isDefined } from "Utils/functions";
import React from "react";
import { InsuranceTermsPdfButton } from "./InsuranceTermsPdfButton";
import { getTermCoverages } from "./utils";

interface Props {
  readonly productBackendName: ProductBackendName;
  readonly coverage?: InsuranceCoverage;
  readonly isOnColoredBackground?: boolean;
}

export const InsuranceTermsPdfButtons = ({
  productBackendName,
  coverage,
  isOnColoredBackground,
}: Props): React.ReactElement => {
  const multipleCoverages = getTermCoverages(productBackendName);

  if (isDefined(multipleCoverages)) {
    return (
      <>
        {multipleCoverages.map((coverage) => (
          <InsuranceTermsPdfButton
            key={coverage}
            specialCoverage={coverage}
            isOnColoredBackground={isOnColoredBackground}
          />
        ))}
      </>
    );
  }

  return (
    <InsuranceTermsPdfButton
      key={productBackendName}
      coverage={coverage}
      productBackendName={productBackendName}
      isOnColoredBackground={isOnColoredBackground}
    />
  );
};
